import React, { useEffect, useState } from "react";
import api from "../../api";
import { useParams, useNavigate } from "react-router-dom";

export default function PracticeQuizPreview() {
  const { id } = useParams();
  const [quizData, setQuizData] = useState(null);
  const [timeLeft, setTimeLeft] = useState(0);
  const nav = useNavigate();

  useEffect(() => {
    loadPreview();
  }, [id]);

  const loadPreview = async () => {
    try {
      const res = await api.get(`/admin/practice_set/preview/${id}`);
      setQuizData(res.data);
      setTimeLeft(res.data.duration_seconds);
    } catch (err) {
      alert("Failed to load practice quiz preview");
      nav("/admin/practice-sets");
    }
  };

  if (!quizData) return <p style={{ padding: 30 }}>Loading...</p>;

  return (
    <div style={{ padding: 30 }}>
      <h1>🧠 Preview Quiz (Practice)</h1>
      <p>⏱ Remaining Time: {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, "0")}</p>
      <hr />

      {quizData.questions.map((q, index) => (
        <div key={q.id} style={{ marginTop: 30, border: "1px solid #ddd", borderRadius: 8, padding: 20 }}>
          <h3>{index + 1}. {q.text}</h3>
          <div style={{ marginTop: 10 }}>
            <label><input type="radio" name={`q_${q.id}`} /> A: {q.option_a}</label><br />
            <label><input type="radio" name={`q_${q.id}`} /> B: {q.option_b}</label><br />
            <label><input type="radio" name={`q_${q.id}`} /> C: {q.option_c}</label><br />
            <label><input type="radio" name={`q_${q.id}`} /> D: {q.option_d}</label><br />
          </div>
        </div>
      ))}

      <button
        style={{
          marginTop: 30,
          padding: "12px 20px",
          background: "#2563eb",
          color: "white",
          border: "none",
          borderRadius: 8,
          cursor: "pointer"
        }}
        onClick={() => nav(-1)}
      >
        Back
      </button>
    </div>
  );
}
